export const GENERATED_REPORTS_TEXTS = {
  // Page heading
  PAGE_TITLE: 'Reports',

  // Table columns
  COLUMN_NAME: 'Name',
  COLUMN_DATE_CREATED: 'Date Created',
  COLUMN_CREATED_BY: 'Created By',
  COLUMN_STATUS: 'Status',
  COLUMN_ACTIONS: 'Actions',

  // Actions
  ACTION_DOWNLOAD: 'Download',
  ACTION_DELETE: 'Delete',
  DOWNLOAD_NOT_READY_TOOLTIP: 'Report is not ready for download',

  // Delete confirmation
  DELETE_DIALOG_TITLE: 'Delete Report?',
  DELETE_DIALOG_CONTENT: 'Are you sure you want to delete this report? This action cannot be undone.',
  DELETE_DIALOG_CONFIRM: 'Delete',

  // Empty state
  EMPTY_STATE_TITLE: 'No reports found',
  EMPTY_STATE_FIRST_REPORT: 'Generate your first report from a template',
  EMPTY_STATE_ADJUST_FILTERS: 'Try adjusting your filters',

  // Filter labels
  FILTER_SEARCH_LABEL: 'Search',
  FILTER_STATUS_LABEL: 'Status',
  FILTER_STATUS_ALL: 'All statuses',
  FILTER_START_DATE: 'Start Date',
  FILTER_END_DATE: 'End Date',

  // Status options
  STATUS_INITIAL: 'Initial',
  STATUS_PROCESSING: 'Processing',
  STATUS_COMPLETED: 'Completed',
  STATUS_FAILED: 'Failed',

  // Search panel
  FILTER_TITLE: 'Search Reports',
  FILTER_SEARCH_BUTTON: 'Search',
  FILTER_CLEAR_BUTTON: 'Clear',

  // Generate dialog
  GENERATE_BUTTON: 'Generate New',
  GENERATE_DIALOG_TITLE: 'Generate New Report',
  GENERATE_DIALOG_NAME_LABEL: 'Report Name',
  GENERATE_DIALOG_NAME_PLACEHOLDER: 'Enter a name for this report',
  GENERATE_DIALOG_TEMPLATE_LABEL: 'Report Template',
  GENERATE_DIALOG_SUBMIT: 'Generate',
  GENERATE_DIALOG_NO_TEMPLATES: 'No active templates available',
  GENERATE_DIALOG_AS_OF_DATE_LABEL: 'As of Date',
  GENERATE_DIALOG_AS_OF_DATE_LIVE: 'Live Data (Current)',
  GENERATE_DIALOG_FORMAT_LABEL: 'Format',
} as const;
